import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9jg4fbzgpg: FaireBrandEntity = {
  token: "b_9jg4fbzgpg",
  type: "brand",
  name: "Like International",
  avatarUrl:
    "https://cdn.faire.com/fastly/339b27a9659d162d4a01b6f8af51da4ecf5ed97afeeff99bac52ddec3965b6ac.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/56522c43816f8693fd053018275be2bd1989012e1d361e043eb5f77d2c04bb9b.png",
  logoUrl:
    "https://cdn.faire.com/fastly/339b27a9659d162d4a01b6f8af51da4ecf5ed97afeeff99bac52ddec3965b6ac.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/56522c43816f8693fd053018275be2bd1989012e1d361e043eb5f77d2c04bb9b.png",
  location: "Roseville , CA, USA",
  minimumOrderDollars: 144,
  rating: 5,
  reviewCount: 5,
  isInsider: true,
  description:
    "Like International is dedicated to their mission of spreading positivity through their colorful, one-of-a-kind, handmade products from Nepal. With a unique selection of products including eco-friendly Himalayan Hemp backpacks, boho dresses, vibrant tapestries, funky pants, statement fannypacks, and more, they truly have something for everyone. At Like International, they believe that visually attractive products should go hand in hand with functionality so hidden pockets, easy use, and durable materials are never a second priority. \n\nThey also believe that you can not spread positivity without mental wellness. So, their products also include meditation and metaphysical items such as Himalayan Singing Bowls, Homegrown Sage, Palo Santo, Tibetan bells, and so much more. It is Like International's goal to spread positivity and promote wellness as a immigrant-owned family small business.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:10.621Z",
    importedBy: "entity-db-cli",
  },
};
